import React, { useState, useEffect } from "react";
import profile from "../../assets/avatar.png";
import "./home.css";
import { Link } from "react-router-dom";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../Config/Firebase/config";
import { toast } from "react-toastify";

const Home = () => {
  const texts = ["Brand Identity Design", "UX/UI Design", "Packaging Design", "Marketing & Advertising Design", "Art & Illustration", "Print & Publication Design"];
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentText, setCurrentText] = useState("");
  const [typingIndex, setTypingIndex] = useState(0);
  const [featuredData, setFeaturedData] = useState([]);

  useEffect(() => {
    if (typingIndex < texts[currentIndex].length) {
      const interval = setInterval(() => {
        setTypingIndex((prevIndex) => prevIndex + 1);
      }, 100);

      return () => clearInterval(interval);
    } else {
      setTimeout(() => {
        setCurrentText("");
        setTypingIndex(0);
        setCurrentIndex((prevIndex) => (prevIndex + 1) % texts.length);
      }, 2000);
    }
  }, [typingIndex, currentIndex]);

  useEffect(() => {
    setCurrentText(texts[currentIndex].substring(0, typingIndex));
  }, [typingIndex, currentIndex]);

  useEffect(() => {
    const CACHE_KEY = "featureCache";
    const CACHE_EXPIRATION = 7 * 24 * 60 * 60 * 1000;
    const featureCollectionRef = collection(db, "featured");
    const getFeaturedData = async () => {
      try{
        const data  = await getDocs(featureCollectionRef);
        const filteredData = data.docs.map((doc) => ({
          ...doc.data(),
          id: doc.id,
        }))
        setFeaturedData(filteredData);
        const currentTime = new Date().getTime();
        const cachedData = {
            data: filteredData,
            timestamp: currentTime,
        };
        localStorage.setItem(CACHE_KEY, JSON.stringify(cachedData));
      }catch(error){
         toast.error("Could not Load Project Data");
      }
    };
    const cachedData = localStorage.getItem(CACHE_KEY);
    if (cachedData) {
        const { data, timestamp } = JSON.parse(cachedData);
        const currentTime = new Date().getTime();
        if (currentTime - timestamp <= CACHE_EXPIRATION) {
            setFeaturedData(data);
        } else {
            getFeaturedData();
        }
    } else {
        getFeaturedData();
    }
  }, []);

  return (
    <section className="home section" id="home">
      <div className="container">
        <div className="row">
          <div className="home-info padd-15">
            <h3 className="hello">
              Welcome to <span className="name">Santalum Designs</span>
            </h3>
            <h4 className="my-profession">
              Our Services <span className="typing">{currentText}</span>
            </h4>
            <p className="home-desc">
              We are a dedicated team of highly skilled and creative graphics designers who are
              truly passionate about crafting captivating visual experiences. Our YouTube channel
              is a heaven for all design enthusiasts, where we share our expertise and insights
              into the world of graphic design. With a diverse skill set encompassing Brand Identity
              Design, Print and Publication Design, UX/UI Design, and many more. We are committed to
              bringing your ideas to life and helping your brand stand out in a crowd.
            </p>
            <div className="row">
              <div className="buttons padd-15">
                <Link to={`/blog`} className="btn">Blog</Link>
                <a href='https://youtube.com/@santalumdesigns' rel="noreferrer" target="_blank" className="youtube btn">YouTube</a>
              </div>
            </div>
          </div>
          {
            featuredData.length !== 0 ? 
            <div className="home-featured padd-15">
              <h3 className="featured-item">Featured</h3>
              <img src={featuredData[0].image} alt="chandan" />
              <p className="featured-title">{featuredData[0].title}</p>
              <a href={featuredData[0].link} rel="noreferrer" target="_blank" className="youtube btn">Start Watching Now</a>
            </div> : <div></div>
          }
        </div>
      </div>
    </section>
  );
};

export default Home;
